// Altcha proof-of-work client for the marketing site's public forms: fetch a
// challenge from web-api and solve it with the shared solver. The result goes
// in the `x-altcha-solution` header the `AltchaGuard` expects. No third-party
// service, no widget dependency.
import { solveAltchaChallenge, type AltchaChallengePayload } from '@munifocus/utils';
import { api } from './api-client';

/**
 * Obtain a solved Altcha payload for a public form submission. Returns the
 * base64 string to send as `x-altcha-solution`. Throws on network/solve failure
 * so the caller can surface an error rather than submit unverified.
 */
export async function solveAltcha(): Promise<string> {
  const { data } = await api.get<AltchaChallengePayload>('/altcha/challenge');
  return solveAltchaChallenge(data);
}
